import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/root';
import { listenerMiddleware } from './slices/listenerMiddleware';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }).prepend(listenerMiddleware.middleware),
});

if (import.meta.hot) {
  import.meta.hot.accept('./reducers/root', () => store.replaceReducer(rootReducer));
}

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
